export default {
    title: {
        hotPromotion: 'รวมโปรร้อนแรง',
        special4You: 'พิเศษเฉพาะคุณ',
        promoCode: 'รหัสส่วนลด',
        searchPromotion: 'ค้นหา'
    },
    bottomSheet: {
        register: 'พิเศษสำหรับคุณเท่านั้น !! อย่าลืมลงทะเบียนในเมนูข้อมูลส่วนตัว เพื่อรับข่าวสารและโปรโมชันสุดพิเศษจาก JCB',
        confirmRedeemDesc: 'กรุณาตรวจสอบเงื่อนไขก่อนดำเนินการ',
        addCard: 'กรุณาทำการเพิ่มบัตรเครดิต JCB <br />เพื่อรับสิทธิพิเศษมากมาย'
    },
    tabs: {
        detail: 'รายละเอียด',
        condition: 'เงื่อนไข'
    },
    historyTabs: {
        available: 'คูปองพร้อมใช้งาน',
        usedExpired: 'คูปองหมดอายุ'
    },
    body:{
        period: "ระยะเวลา",
        presentCode: "โปรดแสดงรหัสส่วนลดที่หน้าร้านค้าเพื่อรับสิทธิพิเศษ",
    },
    comingSoon: "<p class='mb-2'>รายละเอียดของโปรโมชั่นจะปรากฏขึ้นเร็ว ๆ นี้ </p> <p>JCB จะทำการคัดเลือกดีลที่เหมาะสม <br />เพื่อให้คุณได้รับโปรโมชั่นพิเศษเฉพาะคุณเท่านั้น</p>"
}
